import { Card, CardContent } from "./card";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "./carousel";

const testimonials = [
  {
    id: 1,
    content:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
    author: "Jean Kouassi",
    role: "Directeur des Ressources Humaines",
    image: "/images/jean-kouassi.jpg",
  },
  {
    id: 2,
    content:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
    author: "Marie Koné",
    role: "Responsable Formation",
    image: "/images/marie-kone.jpg",
  },
  {
    id: 3,
    content:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
    author: "Paul Diallo",
    role: "Directeur général",
    image: "/images/paul-diallo.jpg",
  },
  {
    id: 4,
    content:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
    author: "Brice Seri",
    role: "Chef de Service",
    image: "/images/brice-seri.jpg",
  },
];

export function Testimonials() {
  return (
    <div className="py-12 bg-[#fefaf6]">
      <div className="max-w-[1350px] mx-auto px-4 mobile:px-2">
        <h2 className="text-3xl mobile:text-2xl font-bold mb-8 mobile:mb-4 font-condensed">
          Temoignages
        </h2>
        <Carousel
          opts={{
            align: "start",
            loop: true,
          }}
          className="w-full relative mobile:mx-[-0.5rem]"
        >
          <CarouselContent className="-ml-2 md:-ml-4">
            {testimonials.map((testimonial) => (
              <CarouselItem
                key={testimonial.id}
                className="pl-2 md:pl-4 mobile:basis-full md:basis-1/3"
              >
                <Card className="bg-white h-full mobile:mx-2">
                  <CardContent className="pt-6 mobile:pt-3 mobile:px-3">
                    <div className="pb-4 flex justify-end mobile:flex-col-2 mobile:flex mobile:items-end mobile:pb-2">
                      <div className="pe-2 mobile:order-2 mobile:text-center mobile:pe-2 mobile:pt-2 mobile:mb-5">
                        <p className="font-semibold text-green-600 text-end mobile:text-base">
                          {testimonial.author}
                        </p>
                        <p className="text-sm text-gray-600 mobile:text-xs font-condensed">
                          {testimonial.role}
                        </p>
                      </div>
                      <div
                        className="mobile:order-2"
                        style={{
                          width: "60px",
                          height: "60px",
                          overflow: "hidden",
                          borderRadius: "15%",
                          marginRight: "15px",
                        }}
                      >
                        <img
                          src={testimonial.image}
                          alt={testimonial.author}
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                          }}
                        />
                      </div>
                    </div>
                    <div className="mb-4 mobile:mb-2">
                      <p className="text-gray-700 mb-4 mobile:text-xs mobile:mb-2 font-light">
                        {testimonial.content}
                      </p>
                    </div>
                  </CardContent>
                </Card>
              </CarouselItem>
            ))}
          </CarouselContent>
          <div className="flex justify-end gap-2 pt-4 mobile:pt-2">
            <CarouselPrevious className="mobile:h-6 mobile:w-6 mobile:absolute mobile:-left-3 mobile:top-1/2 mobile:-translate-y-1/2 bg-[#41a873] text-white" />
            <CarouselNext className="mobile:h-6 mobile:w-6 mobile:absolute mobile:-right-3 mobile:top-1/2 mobile:-translate-y-1/2 bg-[#41a873] text-white" />
          </div>
        </Carousel>
      </div>
    </div>
  );
}
